import { ScrollArea } from '@plaidev/sour-react';
import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/table-definitions')({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <ScrollArea className="h-full" orientation="vertical">
      <div className="p-8">
        <Outlet />
      </div>
    </ScrollArea>
  );
}
